import i18n from 'i18next';
import { registerCondition } from 'core/forms';

const isStatusNoShow = ({ model }) => ({
  condition: null,
  hasCondition: !model.status || model.status === 'no-show'
});

registerCondition('isStatusNoShow', isStatusNoShow);

export default isStatusNoShow;
